<template>
  <header class="no-print" :class="bg ? 'bg' : ''">
    <NavMain :items="menus" :path="path" />
    <NavMainMobile :path="path" />
    <busca />
    <keep-alive>
      <component v-bind:is="showComponentHeader" />
    </keep-alive>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NavMain from './NavMain';
import NavMainMobile from './NavMainMobile';
import Busca from '@/components/layout/header/Busca.vue';
import Notificacoes from '@/components/Notificacoes.vue';

export default {
  name: 'Header',
  props: {
    path: {
      type: [String, Object],
      default: () => ({ name: 'home' }),
    },
    bg: {
      type: Boolean,
      default: false,
    },
    hideCollapse: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NavMain,
    NavMainMobile,
    Busca,
    Notificacoes,
  },
  computed: {
    ...mapGetters({
      menus: 'menu/categorias',
      categorias: 'categoria/getCategorias',
      showComponentHeader: 'notificacoes/showComponentHeader',
    }),
  },
  methods: {
    ...mapActions({
      showModal: 'modal/showModal',
      menuHeader: 'menu/menuHeader',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.categorias) this.menuHeader(this.categorias);
    });
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.bg {
  @extend %gradiente_twilight;
  width: 100%;
  // height: 85px;
  // opacity: 0.99;
  // position: absolute;
  // top: 0;
  // left: 0;
  // z-index: -2;
}

header {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-center;
  @extend %align-items-center;
  user-select: none;
  z-index: 10000;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  // padding: 10px 0px;
  transition: all 0.5s ease-in-out;
}
</style>
